import { createFileRoute } from '@tanstack/react-router'

import VerificationDataPage from '@/components/pages/backoffice/_verification-data/containers/VerificationDataPage'

export const Route = createFileRoute('/_backoffice/verification-data/')({
  component: VerificationDataPage
})
